import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';

import { Observable } from 'rxjs';

import { environment } from '../../environments/environment';

/** Read-only views of agency-owned config (staff / agency staff). Checklist/workflow and trigger/notification/cron archives are agency-scoped. */
@Injectable({ providedIn: 'root' })
export class AgencyOverviewService {
  constructor(private http: HttpClient) {}

  private overviewBase(agencyId: string): string {
    return `${environment.apiBaseUrl}/agencies/${agencyId}/overview`;
  }

  listOptions(agencyId: string, scope: 'task_list' | 'forms' | 'settings'): Observable<{ options: AgencyOverviewOption[] }> {
    const params = new HttpParams().set('scope', scope);
    return this.http.get<{ options: AgencyOverviewOption[] }>(`${this.overviewBase(agencyId)}/options`, { params });
  }

  /**
   * @param companyId omit for checklist/workflow and for trigger/notification/cron archives (agency template only). Optional otherwise for response metadata.
   */
  getSnapshot(agencyId: string, entityType: string, companyId?: string | null): Observable<any> {
    let params = new HttpParams().set('entity_type', entityType);
    if (companyId) {
      params = params.set('company_id', companyId);
    }
    return this.http.get(`${this.overviewBase(agencyId)}/snapshot`, { params });
  }

  getForms(agencyId: string, companyId: string, bureauId?: string): Observable<any> {
    let params = new HttpParams().set('company_id', companyId);
    if (bureauId) {
      params = params.set('bureau_id', bureauId);
    }
    return this.http.get(`${this.overviewBase(agencyId)}/forms`, { params });
  }
}

export interface AgencyOverviewOption {
  company_id: string;
  company_name: string;
  bureaus: { id: string; name: string }[];
}
